import { _goToBack } from "routers/helper";
import { Keys } from "../_keys";
import client from "clients/configs";

export const onResponseCreateTypeOfMeeting = (data: any, error: any) => {
  if (!error) {
    const newItem = { ...data?.data?.data };

    client.setQueryData([Keys.TYPE_OF_MEETINGS], (prev: any) => {
      const prevItems = prev?.data?.data?.items;

      const newItems = [...prevItems, newItem];

      return { data: { data: { items: newItems } } };
    });
  }
};

export const onSuccessDeleteTypeOfMeeting = (
  data: any,
  error: any,
  variables: any
) => {
  if (!error) {
    const deletedTypeOfMeetingId = variables?.id;

    client.setQueryData([Keys.TYPE_OF_MEETINGS], (prev: any) => {
      const prevItems = prev?.data?.data?.items;
      const newItems = prevItems?.filter(
        (e: any) => e.id !== deletedTypeOfMeetingId
      );

      return { data: { data: { items: newItems } } };
    });
  }
};

export const onResponseUpdateTypeOfMeeting = (
  data: any,
  error: any,
  variables: any
) => {
  if (!error) {
    const updatedItem = { ...variables };

    client.setQueryData([Keys.TYPE_OF_MEETINGS], (prev: any) => {
      const prevItems = prev?.data?.data?.items;

      const newItems = prevItems.map((e: any) => {
        if (e.id === updatedItem.id) {
          return updatedItem;
        }
        return e;
      });

      return { data: { data: { items: newItems } } };
    });
  }
};

export const onResponseUpdateApkVersion = (
  data: any,
  error: any,
  variables: any
) => {
  if (!error) {
    _goToBack();
  }
};
